<template>
    <div class="">
        <Header></Header>

        <!-- Upload Overlay -->
        <div v-if="uploading" class="upload-overlay">
          <div class="upload-modal">
            <div class="spinner-border text-primary" role="status"></div>
            <div class="mt-2">{{ uploadMessage }}</div>
            <div class="progress mt-2" style="height: 20px;">
              <div class="progress-bar" role="progressbar" :style="{width: uploadProgress + '%'}">
                {{ uploadProgress }}%
              </div>
            </div>
          </div>
        </div>
        <!-- End Upload Overlay -->

        <!-- Main -->
        <main class="u-main">
            <Navigation></Navigation>

            <div class="u-content">
                <div class="u-body min-h-700">
                    <h1 class="h2 mb-2 text-capitalize"> {{ refs }}
                        
                        <!-- Tenants -->
                        <div class="pull-right ui-mt-15">
                            <span class="btn btn-dark btn-sm">
                                <span class="btn-icon ti-home mr-2"></span>
                                <span> {{ tenant_name }} </span>
                            </span>
                        </div>
                        <!-- End Tenants -->
                        
                    </h1>

                    <!-- Breadcrumb -->
                    <nav aria-label="breadcrumb">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item">
                                <router-link :to="{ name: 'dashboard' }">Home</router-link>
                            </li>
                            <li class="breadcrumb-item text-capitalize">
                                <router-link :to="{ name: refs }">{{ refs }}</router-link>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">Edit</li>
                        </ol>
                    </nav>
                    <!-- End Breadcrumb -->

        <div v-if="pgLoading" class="row h-100">
            <div class="container text-center">
                <div class="spinner-grow mt-5" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
            </div>
        </div>

        <form v-if="!pgLoading" @submit.prevent="editRow" enctype="multipart/form-data" class="h-100">

            <!-- Content -->
            <div class="tab-content">
                <div class="row">      

                
                 <!-- ******* Cards ******* -->  
                <div class="col-md-8 mb-5">

                    <!-- Card Meta -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabMeta" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Meta')"
                                        aria-expanded="false" 
                                        aria-controls="collapseMeta" 
                                        data-toggle="collapse"
                                        data-target="#collapseMeta">Meta
                                        <span id="iconToggleMeta" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMeta" 
                                    class="collapse show" 
                                    aria-labelledby="TabMeta" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- Meta title -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_title"
                                                v-text="(row.meta_title.length)">
                                            </div>
                                            <label for="metaText1">Meta title</label>
                                            <input class="form-control"
                                                    id="metaText1"  
                                                    type="text" 
                                                    v-model="row.meta_title">
                                        </div>
                                        <!-- End Meta title -->
                                            
                                        <!-- Meta keywords -->
                                        <div class="form-group">
                                            <div class="pull-right f12"
                                                v-if="row.meta_keywords" 
                                                v-text="(row.meta_keywords.length)">
                                            </div>
                                            <label for="metaText2">Meta keywords</label>
                                            <textarea class="form-control"
                                                    id="metaText2" 
                                                    rows="5"  
                                                    v-model="row.meta_keywords">
                                            </textarea>
                                        </div>
                                        <!-- End Meta keywords -->

                                        <!-- Meta description -->
                                        <div class="form-group">
                                            <div class="pull-right f12" 
                                                v-if="row.meta_description" 
                                                v-text="(row.meta_description.length)">
                                            </div>
                                            <label for="metaText3">Meta description</label>
                                            <textarea class="form-control" 
                                                    id="metaText3" 
                                                    rows="5" 
                                                    v-model="row.meta_description">
                                            </textarea>
                                        </div>
                                        <!-- End Meta description -->

                                    </div>

                                    <div class="row">
                                        <div class="col-6 pt-3">
                                            <!-- Site Map Changefreq -->
                                            <div class="form-group">
                                                <label for="inputText444">Site Map Changefreq</label>
                                                <select class="form-control" 
                                                        id="inputText444" 
                                                        v-model="row.sitemap_freq">
                                                    <option value="always">always</option>
                                                    <option value="hourly">hourly</option>
                                                    <option value="daily">daily</option>
                                                    <option value="weekly">weekly</option>
                                                    <option value="monthly" selected>monthly</option>
                                                    <option value="yearly">yearly</option>
                                                    <option value="never">never</option>
                                                </select>
                                            </div>
                                            <!-- Site Map Changefreq -->
                                        </div>

                                        <div class="col-6 pt-3">
                                            <!-- Site Map Priority -->
                                                <div class="form-group">
                                                    <label for="inputText555">Site Map Priority</label>
                                                    <select class="form-control" 
                                                            id="inputText555" 
                                                            v-model="row.sitemap_priority">
                                                        <option value="0.0">0.0</option>
                                                        <option value="0.1">0.1</option>
                                                        <option value="0.2">0.2</option>
                                                        <option value="0.3">0.3</option>
                                                        <option value="0.4">0.4</option>
                                                        <option value="0.5" selected>0.5</option>
                                                        <option value="0.6">0.6</option>
                                                        <option value="0.7">0.7</option>
                                                        <option value="0.8">0.8</option>
                                                        <option value="0.9">0.9</option>
                                                        <option value="1.0">1.0</option>
                                                    </select>
                                                </div>
                                            <!-- End Site Map Priority -->
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Meta -->

                    <!-- Card Package -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabPackage" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Package')"
                                        aria-expanded="false" 
                                        aria-controls="collapseCruise" 
                                        data-toggle="collapse"
                                        data-target="#collapsePackage">Package
                                        <span id="iconTogglePackage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                                pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapsePackage" 
                                    class="collapse" 
                                    aria-labelledby="TabPackage" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">
                                        
                                        <!-- Title -->
                                        <div class="form-group">
                                            <label for="inputText1">Title</label>
                                            <input class="form-control" 
                                                    id="inputText1" 
                                                    type="text" 
                                                    v-model="row.title">
                                        </div>
                                        <!-- End Title -->

                                        <!-- Slug -->
                                        <div class="form-group">
                                            <label for="inputText2">Slug</label><span style="color:red"> *</span>
                                            <input class="form-control"
                                                    id="inputText2"  
                                                    type="text" 
                                                    v-model="row.slug" 
                                                    @keydown.space.prevent>
                                        </div>
                                        <!-- End Slug -->

                                        <!-- Title -->
                                        <div class="form-group">
                                            <label for="inputText3">Short title</label>
                                            <input class="form-control" 
                                                    id="inputText3" 
                                                    type="text" 
                                                    v-model="row.short_title">
                                        </div>
                                        <!-- End Title -->

                                        
                                        <div class="col-12 row no-padding ui-ml-unset">
                                            <!-- Popular -->
                                            <div class="col-8 no-lpadding">
                                                <div class="form-group">
                                                    <label for="inputText4">Popular</label>
                                                    <select class="form-control" 
                                                            id="inputText4" 
                                                            v-model="row.popular">
                                                        <option value="">Select Popular</option>
                                                        <option value="popular">Popular</option>
                                                        <option value="topRated">Top rated</option>
                                                        <option value="bestSeller">Best seller</option>
                                                        <option value="bestDeal">Best deal</option>
                                                        <option value="easterOffer">Easter offer</option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!-- End Popular -->

                                            <!-- Start Price -->
                                            <div class="col-4 no-rpadding">
                                                <div class="form-group">
                                                    <label for="inputText5">Start price</label>
                                                    <input class="form-control" 
                                                            id="inputText5" 
                                                            type="number"
                                                            min="0"
                                                            v-model.number="row.start_price">
                                                </div>
                                            </div>
                                            <!-- End Start Price -->

                                            <!-- Start have_discount -->
                                            <div class="col-4 no-rpadding">
                                                <div class="form-group">
                                                    <label>Have Discount</label>
                                                    <div class="custom-control custom-checkbox">
                                                        <input id="exampleCheck5" class="custom-control-input" type="checkbox" :checked="row.have_discount" @click="haveDiscount">
                                                        <label class="custom-control-label" for="exampleCheck5">have discount</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- End have_discount -->

                                            <!-- Discount -->
                                            <div class="col-4 no-lpadding">
                                                <div class="form-group">
                                                    <label for="inputText26">Discount (%)</label>
                                                    <input class="form-control" 
                                                            id="inputText26" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.discount">
                                                </div>
                                            </div>
                                            <!-- End Discount -->

                                            <!-- Free Photo Session -->
                                            <div class="col-4 no-lpadding">
                                                <div class="form-group">
                                                    <label>Free Photo Session</label>
                                                    <div class="custom-control custom-checkbox">
                                                        <input id="exampleCheck55" class="custom-control-input" type="checkbox" :checked="row.free_photo_session" @click="haveFreePhotoSession">
                                                        <label class="custom-control-label" for="exampleCheck55">free photo session</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <!-- End Free Photo Session -->
                                            

                                            <!-- Stars -->
                                            <div class="col-4 no-lpadding">
                                                <div class="form-group">
                                                    <label for="inputText6">Stars</label>
                                                    <input class="form-control" 
                                                            id="inputText6" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.stars">
                                                </div>
                                            </div>
                                            <!-- End Stars -->

                                            <!-- Stars No. -->
                                            <div class="col-4">
                                                <div class="form-group">
                                                    <label for="inputText7">Stars No.</label>
                                                    <input class="form-control" 
                                                            id="inputText7" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.stars_no">
                                                </div>
                                            </div>
                                            <!-- End Stars No. -->

                                            <!-- Sort -->
                                            <div class="col-4 no-rpadding">
                                                <div class="form-group">
                                                    <label for="inputText8">Sort</label>
                                                    <input class="form-control" 
                                                            id="inputText8" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.sort">
                                                </div>
                                            </div>
                                            <!-- End Sort -->
                                        </div>


                                        <!-- TourType -->
                                        <div class="form-group">
                                            <label for="inputText9">Tour Type</label>
                                            <input class="form-control" 
                                                    id="inputText9" 
                                                    type="text" 
                                                    v-model="row.tour_type">
                                        </div>
                                        <!-- End TourType -->

                                        <div class="row">
                                            <!-- Sort Duration -->
                                            <div class="col-4">
                                                <div class="form-group">
                                                    <label for="inputText88">Sort Duration</label>
                                                    <input class="form-control" 
                                                            id="inputText88" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.sort_duration">
                                                </div>
                                            </div>
                                            <!-- End Sort Duration -->

                                            <!-- Duration -->
                                            <div class="col-8">
                                                <div class="form-group">
                                                    <label for="inputText10">Duration</label>
                                                    <input class="form-control" 
                                                            id="inputText10" 
                                                            type="text" 
                                                            v-model="row.duration">
                                                </div>
                                            </div>
                                            <!-- End Duration -->
                                        </div>

                                        <!-- Run Dates -->
                                        <div class="form-group">
                                            <label for="inputEditor7">Run Dates</label>
                                            <input class="form-control" 
                                                    id="inputText7" 
                                                    type="text" 
                                                    v-model="row.run_dates">
                                        </div>
                                        <!-- End Run Dates -->

                                        <!-- Guide Language -->
                                        <div class="form-group">
                                            <label for="inputEditor8">Guide Language</label>
                                            <input class="form-control" 
                                                    id="inputText8" 
                                                    type="text" 
                                                    v-model="row.guide_lang">
                                        </div>
                                        <!-- End Guide Language -->

                                        <!-- Visited Location -->
                                        <div class="form-group">
                                            <label for="inputEditor1">Visited Location</label>
                                            <editor
                                                id="inputEditor1"
                                                v-model="row.visited_locations"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Visited Location -->

                                        <!-- Inclusion -->
                                        <div class="form-group">
                                            <label for="inputEditor2">Inclusion</label>
                                            <editor
                                                id="inputEditor2"
                                                v-model="row.inclusion"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Inclusion -->

                                        <!-- Exclusion -->
                                        <div class="form-group">
                                            <label for="inputEditor3">Exclusion</label>
                                            <editor
                                                id="inputEditor3"
                                                v-model="row.exclusion"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Exclusion -->

                                        <!-- Price Note -->
                                        <div class="form-group">
                                            <label for="inputEditor6">Price Note</label>
                                            <editor
                                                id="inputEditor6"
                                                v-model="row.price_note"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Price Note -->

                                        <!-- Short Body -->
                                        <div class="form-group">
                                            <label for="inputEditor4">Short body</label>
                                            <editor
                                                id="inputEditor4"
                                                v-model="row.short_body"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 300,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Short Body -->

                                        <!-- Body -->
                                        <div class="form-group">
                                            <label for="inputEditor5">body</label>
                                            <editor
                                                id="inputEditor5"
                                                v-model="row.body"
                                                :api-key="editor.api_key"
                                                :init="{
                                                    height: 600,
                                                    menubar: editor.menubar,
                                                    plugins: editor.plugins,
                                                    external_plugins: editor.external_plugins,
                                                    toolbar: editor.toolbar
                                                }"
                                            />
                                        </div>
                                        <!-- End Body -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Cruise -->

                    <!-- Card Price -->
                    <div class="card mt-5" style="display: none">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabPrices" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Prices')"
                                        aria-expanded="false" 
                                        aria-controls="collapsePrices" 
                                        data-toggle="collapse"
                                        data-target="#collapsePrices">Prices
                                        <span id="iconTogglePrices" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapsePrices" 
                                    class="collapse" 
                                    aria-labelledby="TabPrices" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                            <!-- For Loop -->
                                            <div v-for="i in row.price_key" 
                                                :key="i" 
                                                :class="(i == 0) ? 'hidden' : ''"
                                                :id="'frm_'+i"
                                                class="ui-for-div">

                                                 <!-- Remove -->
                                                <div class="pull-right ui-mt-10">
                                                    <button v-if="i != 0"
                                                        type="button" 
                                                        class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                        @click="removeOption(i)">
                                                        <span class="btn-icon ti-close font-bold"></span>
                                                     </button>
                                                </div>
                                                <!-- End Remove -->

                                                <!-- Price Name -->
                                                <div class="form-group">
                                                    <label :for="'iInput'+i">Price Name</label>
                                                    <input class="form-control" 
                                                            :id="'iInput'+i" 
                                                            type="text" 
                                                            v-model="row.price_names[i]">
                                                </div>
                                                <!-- End Price Name -->

                                                
                                                <!-- Price Items -->
                                               <div v-for="x in 10" 
                                                    :key="x" 
                                                    :class="((prices_items_length[i-1])
                                                             ? x > prices_items_length[i-1]
                                                             : x > 1 )
                                                            ? 'hidden' : ''"
                                                    :id="'sub_'+i+'_'+x">

                                                    <div class="row col-12 ui-ml-unset">
                                                        <div class="form-group col-1"></div>
                                                        <div class="form-group col-5">
                                                            <label :for="'pvInput'+i+'_'+x">Price Value</label>
                                                            <input class="form-control" 
                                                                    :id="'pvInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.price_item_value[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-5">
                                                            <label :for="'pcInput'+i+'_'+x">Content</label>
                                                            <input class="form-control" 
                                                                    :id="'pcInput'+i+'_'+x" 
                                                                    type="text" 
                                                                    v-model="row.price_item_body[i+'_'+x]">
                                                        </div>
                                                        <div class="form-group col-1">
                                                            <button type="button" 
                                                                v-if="x != 0"
                                                                @click="removeSubOption(i,x)"
                                                                class="btn btn-circle btn-with-icon ui-mt30">
                                                                <span class="btn-icon ti-close font-bold"></span>
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                                <!-- End Price Items -->

                                                <!-- Price add more -->
                                                <div class="form-group col-1">
                                                    <button type="button" 
                                                        @click="opnSub(i)"
                                                        class="btn btn-secondary btn-circle btn-with-icon ui-mt30 ui-ml-20">
                                                        <span class="btn-icon ti-plus font-bold"></span>
                                                    </button>
                                                </div>
                                                <!-- End Price add more -->
                                            </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Price -->

                    <!-- Card Itineraries -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabItineraries" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Itineraries')"
                                        aria-expanded="false" 
                                        aria-controls="collapseItineraries" 
                                        data-toggle="collapse"
                                        data-target="#collapseItineraries">Itineraries
                                        <span id="iconToggleItineraries" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseItineraries" 
                                    class="collapse" 
                                    aria-labelledby="TabItineraries" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                            <!-- For Loop -->
                                            <div v-for="i in row.itinerarie_key" 
                                                :key="'i2'+i" 
                                                :class="(i == 0) ? 'hidden' : ''"
                                                :id="'frm2_'+i"
                                                class="ui-for-div">

                                                 <!-- Remove -->
                                                <div class="pull-right ui-mt-10">
                                                    <button v-if="i != 0"
                                                        type="button" 
                                                        class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                        @click="removeOption2(i)">
                                                        <span class="btn-icon ti-close font-bold"></span>
                                                     </button>
                                                </div>
                                                <!-- End Remove -->

                                                <!-- Itinerarie Name -->
                                                <div class="form-group">
                                                    <label :for="'iInput'+i">Itinerarie Name</label>
                                                    <input class="form-control" 
                                                            :id="'iInput'+i" 
                                                            type="text" 
                                                            v-model="row.itinerarie_names[i]">
                                                </div>
                                                <!-- End Itinerarie Name -->

                                                <!-- Itinerarie Sort -->
                                                <div class="form-group">
                                                    <label :for="'iSort'+i">Sort</label>
                                                    <input class="form-control" 
                                                            :id="'iSort'+i" 
                                                            min="0"
                                                            type="number" 
                                                            v-model="row.itinerarie_sort[i]">
                                                </div>
                                                <!-- End Itinerarie Sort -->

                                                <!-- Itinerarie Body -->
                                                <div class="form-group">
                                                    <label :for="'iEditor'+i">Body</label>
                                                    <editor
                                                        :id="'iEditor'+i"
                                                        v-model="row.itinerarie_body[i]"
                                                        :api-key="editor.api_key"
                                                        :init="{
                                                            height: 300,
                                                            menubar: editor.menubar,
                                                            plugins: editor.plugins,
                                                            external_plugins: editor.external_plugins,
                                                            toolbar: editor.toolbar
                                                        }"
                                                    />
                                                </div>
                                                <!-- End Itinerarie Body -->

                                                <!-- Itinerarie Meals -->
                                                <div class="form-group">
                                                    <label :for="'iInput'+i">Itinerarie Meals</label>
                                                    <input class="form-control" 
                                                            :id="'iInput'+i" 
                                                            type="text" 
                                                            v-model="row.itinerarie_meals[i]">
                                                </div>
                                                <!-- End Itinerarie Meals -->

                                                <!-- Itinerarie Accomodation -->
                                                <div class="form-group">
                                                    <label :for="'iInput'+i">Itinerarie Accomodation</label>
                                                    <input class="form-control" 
                                                            :id="'iInput'+i" 
                                                            type="text" 
                                                            v-model="row.itinerarie_accomodation[i]">
                                                </div>
                                                <!-- End Itinerarie Accomodation -->

                                                <!-- Itinerarie Media -->
                                                <div class="form-group">
                                                    <label :for="'iImage'+i">Itinerarie Media File <small>(images, videos)</small></label>
                                                    <p>
                                                        <img v-if="row.media_preview[i] && isImageFile(row.media_preview[i], i)" :src="row.media_preview[i]" class="custom-image" alt="Preview image">
                                                        
                                                        <video v-else-if="row.media_preview[i] && isVideoFile(row.media_preview[i], i)" :src="row.media_preview[i]" class="custom-video" controls preload="metadata" width="200px" height="auto">
                                                            Your browser does not support the video tag.
                                                        </video>
                                                        
                                                        <span v-else-if="row.media_preview[i]" class="unsupported-file">
                                                            Unsupported file type
                                                        </span>
                                                    </p>
                                                    <input class="form-control"
                                                           :id="'iImage'+i"
                                                           type="file"
                                                           accept="image/*,video/*"
                                                           @change="onItinerarieMediaChange($event, i)"
                                                           :disabled="uploading">
                                                </div>
                                                <!-- End Itinerarie Media -->

                                                <!-- Itinerarie Media Link -->
                                                <div class="form-group">
                                                    <label :for="'iImageAlt'+i">Media Link</label>
                                                    <input class="form-control"
                                                           :id="'iImageAlt'+i"
                                                           type="text"
                                                           v-model="row.media_url[i]">
                                                </div>
                                                <!-- End Itinerarie Media Link -->

                                                <!-- Itinerarie Media Alt -->
                                                <div class="form-group">
                                                    <label :for="'iImageAlt'+i">Media Alt</label>
                                                    <input class="form-control"
                                                           :id="'iImageAlt'+i"
                                                           type="text"
                                                           v-model="row.media_alt[i]">
                                                </div>
                                                <!-- End Itinerarie Media Alt -->

                                                <!-- Itinerarie Media Title -->
                                                <div class="form-group">
                                                    <label :for="'iImageTitle'+i">Media Title</label>
                                                    <input class="form-control"
                                                           :id="'iImageTitle'+i"
                                                           type="text"
                                                           v-model="row.media_title[i]">
                                                </div>
                                                <!-- End Itinerarie Media Title -->

                                                <!-- More Media Section -->
                                                <div class="form-group">
                                                  <label><strong>More Media</strong></label>
                                                  <div v-for="media in row.more_media[i] || []" :key="media.id" class="d-flex align-items-center border mb-2" style="gap: 10px;justify-content: space-between;padding: 10px;">
                                                    <div class="d-flex align-items-center" style="gap: 10px;">
                                                        <img v-if="isImageFile(media.url)" :src="media.url" style="max-width: 80px; max-height: 80px;" />
                                                        <video v-else-if="isVideoFile(media.url)" :src="media.url" controls style="max-width: 80px; max-height: 80px;"></video>
                                                        <strong>{{ media.title }}</strong>
                                                        <p class="mb-0">{{ media.short_description }}</p>
                                                    </div>
                                                    <button type="button" class="btn btn-danger btn-sm" @click="removeMoreMedia(i, media.id)">Remove</button>
                                                  </div>
                                                  <!-- Add new more_media forms -->
                                                  <div v-for="(temp, j) in row.more_media_temp[i]" :key="j" class="row gy-3 mb-2">
                                                    <div class="col-12 mb-2">
                                                      <input type="file" class="form-control" :ref="'moreMediaFileInput'+i+'_'+j" @change="onMoreMediaFileChange($event, i, j)" accept="image/*,video/*">
                                                    </div>
                                                    <div class="col-12 mb-2">
                                                      <input type="text" class="form-control" v-model="temp.link" placeholder="OR Add Link">
                                                    </div>
                                                    <div class="col-4">
                                                      <input type="text" class="form-control" v-model="temp.title" placeholder="Title">
                                                    </div>
                                                    <div class="col-4">
                                                      <input type="text" class="form-control" v-model="temp.short_description" placeholder="Short Description">
                                                    </div>
                                                    <div class="col-4">
                                                      <button type="button" class="btn btn-success" @click="addMoreMedia(i, j)"
                                                        :disabled="temp.uploading || (!temp.title || (!temp.url && !temp.link))">
                                                        <span v-if="temp.uploading">Uploading...</span>
                                                        <span v-else>Add</span>
                                                      </button>
                                                    </div>
                                                    <div v-if="temp.uploading" class="col-12 mt-2">
                                                      <div class="progress" style="height: 10px;">
                                                        <div class="progress-bar" role="progressbar"
                                                          :style="{width: (temp.progress || 0) + '%'}">
                                                          {{ temp.progress || 0 }}%
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div class="my-2 pull-left">
                                                    <button type="button" class="btn btn-primary btn-with-icon" @click="opnMoreMedia(i)">
                                                      <span class="btn-icon ti-plus font-bold"></span>
                                                    </button>
                                                  </div>
                                                </div>
                                            </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm2()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Itineraries -->


                    <!-- Card Galeries -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabGalleries" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Galleries')"
                                        aria-expanded="false" 
                                        aria-controls="collapseGalleries" 
                                        data-toggle="collapse"
                                        data-target="#collapseGalleries">Galleries
                                        <span id="iconToggleGalleries" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                    </div>
                                    <div id="collapseGalleries" 
                                        class="collapse" 
                                        aria-labelledby="TabIGalleries" 
                                        data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- For Loop -->
                                        <div v-for="i in row.gallery_key" 
                                            :key="'i3'+i" 
                                            :class="(i == 0) ? 'hidden' : ''"
                                            :id="'frm3_'+i"
                                            class="ui-for-div">

                                             <!--  Remove -->
                                            <div class="pull-right ui-mt-10">
                                                <button v-if="i != 0"
                                                    type="button" 
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeOption3(i)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                 </button>
                                            </div>
                                            <!-- End Remove -->

                                            <!-- Itineraries Title -->
                                            <div class="form-group">
                                                <label :for="'gImageText'+i">Image</label>
                                                <p>
                                                    <img v-if="(row.gallery_image_preview[i])" 
                                                        :src="row.gallery_image_preview[i]" 
                                                        class="custom-image">
                                                </p>
                                                <input class="form-control" 
                                                        :id="'gImageText'+i" 
                                                        type="file"
                                                        v-on:change="onGalleryImageChange($event, i)">
                                            </div>
                                            <!-- End Itineraries Title -->

                                            <div class="col-12 row no-padding ui-ml-unset">
                                                <div class="col-6 no-lpadding">
                                                    <div class="form-group">
                                                        <label :for="'gAltText'+i">Image Alt</label>
                                                        <input class="form-control" 
                                                                :id="'gAltText'+i" 
                                                                type="text"
                                                                v-model="row.gallery_image_alt[i]">
                                                    </div>
                                                </div>

                                                <div class="col-6 no-rpadding">
                                                    <div class="form-group">
                                                        <label :for="'gTitleText'+i">Image Title</label>
                                                        <input class="form-control" 
                                                                :id="'gTitleText'+i"
                                                                type="text"
                                                                v-model="row.gallery_image_title[i]">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End loop -->

                                           <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm3()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Galleries -->

                    <!-- Card Videos -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabVideos" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Videos')"
                                        aria-expanded="false" 
                                        aria-controls="collapseVideos" 
                                        data-toggle="collapse"
                                        data-target="#collapseVideos">Videos
                                        <span id="iconToggleVideos" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow 
                                            pull-right black">
                                        </span>
                                    </h2>
                                    </div>
                                    <div id="collapseVideos" 
                                        class="collapse" 
                                        aria-labelledby="TabIVideos" 
                                        data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                        <!-- For Loop -->
                                        <div v-for="i in row.videos_key" 
                                            :key="'i5'+i" 
                                            :class="(i == 0) ? 'hidden' : ''"
                                            :id="'frm5_'+i"
                                            class="ui-for-div">

                                             <!--  Remove -->
                                            <div class="pull-right ui-mt-10">
                                                <button v-if="i != 0"
                                                    type="button" 
                                                    class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                    @click="removeOption5(i)">
                                                    <span class="btn-icon ti-close font-bold"></span>
                                                 </button>
                                            </div>
                                            <!-- End Remove -->

                                            <!-- Video -->
                                            <div class="form-group">
                                                <label :for="'gVideoText'+i">Video</label>
                                                <p>
                                                    <video v-if="(row.videos_preview[i])" controls class="mb-2 custom-video" width="100%">
                                                        <source :src="row.videos_preview[i]" type="video/mp4">
                                                        Your browser does not support the video tag.
                                                    </video>
                                                </p>
                                                <input class="form-control" 
                                                        :id="'gVideoText'+i" 
                                                        type="file"
                                                        accept="video/*"
                                                        v-on:change="onVideosChange($event, i)">
                                            </div>
                                            <!-- End Video -->

                                            <!-- Video Link -->
                                            <div class="form-group">
                                                <label :for="'gLink'+i">Video Link</label>
                                                <textarea type="text" 
                                                    class="form-control" :id="'gLink'+i"
                                                    v-model="row.videos_link[i]" placeholder="Link or Script"></textarea>
                                            </div>
                                            <!-- End Video Link -->

                                            <div class="col-12 row no-padding ui-ml-unset">
                                                <div class="col-6 no-lpadding">
                                                    <div class="form-group">
                                                        <label :for="'gAltText'+i">Video Alt</label>
                                                        <input class="form-control" 
                                                                :id="'gAltText'+i" 
                                                                type="text"
                                                                v-model="row.videos_alt[i]">
                                                    </div>
                                                </div>

                                                <div class="col-6 no-rpadding">
                                                    <div class="form-group">
                                                        <label :for="'gTitleText'+i">Video Title</label>
                                                        <input class="form-control" 
                                                                :id="'gTitleText'+i"
                                                                type="text"
                                                                v-model="row.videos_title[i]">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <!-- End loop -->

                                           <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm5()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card Videos -->


                    <!-- Card Trip Information -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordion" class="accordion">
                                <div id="TabTripInformation" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('TripInformation')"
                                        aria-expanded="false" 
                                        aria-controls="collapseTripInformation" 
                                        data-toggle="collapse"
                                        data-target="#collapseTripInformation">Trip Information
                                        <span id="iconToggleTripInformation" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseTripInformation" 
                                    class="collapse" 
                                    aria-labelledby="TabTripInformation" 
                                    data-parent="#accordion">

                                    <div class="col-12 pt-3">

                                            <!-- For Loop -->
                                            <div v-for="i in row.trip_information_key" 
                                                :key="'i2'+i" 
                                                :class="(i == 0) ? 'hidden' : ''"
                                                :id="'frm4_'+i"
                                                class="ui-for-div">

                                                 <!-- Remove -->
                                                <div class="pull-right ui-mt-10">
                                                    <button v-if="i != 0"
                                                        type="button" 
                                                        class="btn btn-danger btn-circle btn-with-icon btn-sm"
                                                        @click="removeOption4(i)">
                                                        <span class="btn-icon ti-close font-bold"></span>
                                                     </button>
                                                </div>
                                                <!-- End Remove -->

                                                <!-- Trip Information Name -->
                                                <div class="form-group">
                                                    <label :for="'tInput'+i">Title</label>
                                                    <input class="form-control" 
                                                            :id="'tInput'+i" 
                                                            type="text" 
                                                            v-model="row.trip_information_names[i]">
                                                </div>
                                                <!-- End Trip Information Name -->

                                                <!-- Trip Information Order -->
                                                <div class="form-group">
                                                    <label :for="'tOrder'+i">Order</label>
                                                    <input class="form-control" 
                                                            :id="'tOrder'+i" 
                                                            min="0"
                                                            type="number" 
                                                            v-model="row.trip_information_orders[i]">
                                                </div>
                                                <!-- End Trip Information Order -->

                                                <!-- Trip Information Body -->
                                                <div class="form-group">
                                                    <label :for="'tEditor'+i">Body</label>
                                                    <editor
                                                        :id="'tEditor'+i"
                                                        v-model="row.trip_information_body[i]"
                                                        :api-key="editor.api_key"
                                                        :init="{
                                                            height: 300,
                                                            menubar: editor.menubar,
                                                            plugins: editor.plugins,
                                                            external_plugins: editor.external_plugins,
                                                            toolbar: editor.toolbar
                                                        }"
                                                    />
                                                </div>
                                                <!-- End Trip Information Body -->

                                            </div>

                                            <!-- Add more -->
                                            <div class="row pull-right">
                                                <button type="button" 
                                                    class="btn btn-dark btn-circle btn-with-icon"
                                                    @click="opnFrm4()">
                                                    <span class="btn-icon ti-plus font-bold"></span>
                                                </button>
                                            </div>
                                            <!-- End more -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Card TripInformation -->


                </div>
                <!-- ******* End Cards ******* -->




                <!-- ******* SideNav ******** -->
                <div class="col-md-4 mb-5">

                    <!-- Nav Destination -->
                    <div class="card">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavDestination" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Destination')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavDestination" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavDestination">Destination
                                        <span style="color:red"> *</span>
                                        <span id="iconToggleDestination" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavDestination" 
                                    class="collapse" 
                                    aria-labelledby="NavDestination" 
                                    data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <!-- <span v-if="!destinationLoading" 
                                            @click="fetchDestination()"
                                            class="ti-reload pull-right ui-reload">
                                        </span> -->
                                        
                                        <!-- Destinations -->
                                        <div class="form-group">
                                            <div v-if="destinationLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                    v-if="!destinationLoading" 
                                                    v-model="row.destination_id">
                                                    <option value="">Select Destination</option>
                                                    <optgroup v-for="(region, index) in destinations" 
                                                            :key="index"
                                                            :label="region.title">
                                                        <option v-for="(destination,idx) in region.destinations"
                                                            :key="idx"
                                                            :value="destination.id">
                                                            {{ destination.title }}
                                                        </option>
                                                    </optgroup>
                                            </select>
                                        </div>
                                        <!-- End Destination -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Destination -->

                    <!-- Nav Category -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavCategory" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Category')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavCategory" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavCategory">Category
                                        <span id="iconToggleCategory" 
                                                class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavCategory" 
                                    class="collapse" 
                                    aria-labelledby="NavCategory" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="categoryLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                v-if="!categoryLoading" 
                                                v-model="row.category_id">
                                                <option value="">Select Category</option>
                                                <option v-for="(category, index) in categories" 
                                                        :key="index"
                                                        :value="category.id">
                                                        {{ category.title }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Category -->


                    <!-- Nav Package Types -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavPackageTypes" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('PackageTypes')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavPackageTypes" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavPackageTypes">Package Types
                                        <span id="iconTogglePackageTypes" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavPackageTypes" 
                                        class="collapse" 
                                        aria-labelledby="NavPackageTypes" 
                                        data-parent="#accordionNav">

                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="packageTypesLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <select class="form-control custom-select"
                                                v-if="!packageTypesLoading" 
                                                v-model="row.package_type_id">
                                                <option value="">Select Package Type</option>
                                                <!-- <optgroup v-for="(type, index) in packageTypes" 
                                                        :key="index"
                                                        :label="type.name">
                                                    <option v-for="(ty, idx) in type.childs" 
                                                        :key="idx"
                                                        :value="ty.id">
                                                        {{ ty.name }}
                                                    </option>
                                                </optgroup> -->
                                                <option v-for="(type, index) in packageTypes" 
                                                            :key="index"
                                                            :value="type.id">
                                                            {{ type.name }}
                                                </option>
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Package Types -->


                    <!-- Nav Multiple Destinations -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleDestinations" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultipleDestinations')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultipleDestinations" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultipleDestinations">
                                        Multiple Destinations
                                        <span id="iconToggleMultipleDestinations" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleDestinations" 
                                    class="collapse" 
                                    aria-labelledby="NavMultipleDestinations" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="destinationsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!destinationsLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.destinationsValues" 
                                                    :options="destinationsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search destinations"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Destinations -->



                    <!-- Nav Multiple Acommodations -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleAcommodations" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultipleAcommodations')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultipleAcommodations" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultipleAcommodations">
                                        Multiple Acommodations
                                        <span id="iconToggleMultipleAcommodations" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleAcommodations" 
                                    class="collapse" 
                                    aria-labelledby="NavMultipleAcommodations" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="accommodationsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!accommodationsLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.accommodationsValues" 
                                                    :options="accommodationsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search accommodations"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Acommodations -->


                    <!-- Nav Multiple Hotels -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleHotels" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultipleHotels')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultipleHotels" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultipleHotels">
                                        Multiple Hotels
                                        <span id="iconToggleMultipleHotels" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleHotels" 
                                    class="collapse" 
                                    aria-labelledby="NavMultipleHotels" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="hotelsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!hotelsLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.hotelsValues" 
                                                    :options="hotelsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search hotels"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Hotels -->


                    <!-- Nav Multiple Packages Related -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultiplepackageRelated" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultiplepackageRelated')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultiplepackageRelated" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultiplepackageRelated">
                                        Multiple Packages Related
                                        <span id="iconToggleMultiplepackageRelated" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultiplepackageRelated" 
                                    class="collapse" 
                                    aria-labelledby="NavMultiplepackageRelated" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="packageRelatedLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!packageRelatedLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.packageRelatedValues" 
                                                    :options="packageRelatedOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search packages related"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Packages Related -->

                    <!-- Nav Multiple Tags -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleTags" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultipleTags')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultipleTags" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultipleTags">Multiple Tags
                                        <span id="iconToggleMultipleTags" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleTags" 
                                    class="collapse" 
                                    aria-labelledby="NavMultipleTags" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="tagsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!tagsLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.tagsValues" 
                                                    :options="tagsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search tags"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Tags -->

                    <!-- Nav Multiple Icons -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavMultipleIcons" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('MultipleIcons')" 
                                        aria-expanded="false" 
                                        aria-controls="collapseNavMultipleIcons" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavMultipleIcons">Multiple Icons
                                        <span id="iconToggleMultipleIcons" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavMultipleIcons" 
                                    class="collapse" 
                                    aria-labelledby="NavMultipleIcons" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <div class="form-group">
                                            <div v-if="iconsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!iconsLoading"
                                                    id="multiselect"
                                                    ref="multiselectRef"
                                                    autocomplete="on"
                                                    v-model="row.iconsValues" 
                                                    :options="iconsOptions" 
                                                    :multiple="true"
                                                    :close-on-select="false" 
                                                    :clear-on-select="false" 
                                                    :hide-selected="true" 
                                                    :preserve-search="true" 
                                                    :taggable="false"
                                                    placeholder="Type to search icons"
                                                    :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Multiple Icons -->

                    <!-- Nav Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Image')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseNavImage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavImage">Featued Image
                                        <span id="iconToggleImage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavImage" 
                                    class="collapse" 
                                    aria-labelledby="NavImage" 
                                    data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img :src="row.image_preview" 
                                                class="mb-2 custom-image">
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- End Image -->

                                         <!-- Image alt -->
                                        <div class="form-group">
                                            <label>Image alt</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.image_alt">
                                        </div>
                                        <!-- End Image alt -->
                                        
                                        <!-- Image Title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.image_title">
                                        </div>
                                        <!-- End Image title -->
                                        
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Image -->

                    <!-- Nav Mobile Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="MobileNavImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('MobileImage')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseMobileNavImage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseMobileNavImage">Mobile Featured Image
                                        <span id="iconToggleMobileImage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseMobileNavImage" 
                                    class="collapse" 
                                    aria-labelledby="MobileNavImage" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                            <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img v-if="row.mobile_image_preview"
                                                :src="row.mobile_image_preview" 
                                                class="mb-2 custom-image">
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onMobileImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- Image -->

                                        <!-- Image Alt -->
                                        <div class="form-group">
                                            <label>Image alt</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.mobile_image_alt">
                                        </div>
                                        <!-- End Image Alt -->

                                        <!-- Image Title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.mobile_image_title">
                                        </div>
                                        <!-- End Image Title -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Mobile Image -->

                    <!-- Nav Short Image -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavShortImage" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('ShortImage')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseNavShortImage" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavShortImage">Short Image
                                        <span id="iconToggleShortImage" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavShortImage" 
                                        class="collapse" 
                                        aria-labelledby="NavShortImage" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        
                                        <!-- Image -->
                                        <div class="form-group">
                                            <label>Image</label>
                                            <img :src="row.short_image_preview" 
                                                class="mb-2 custom-image">
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onShortImageChange"
                                                accept="image/*">
                                        </div>
                                        <!-- Image -->

                                        <!-- Image alt -->
                                        <div class="form-group">
                                            <label>Image alt</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.short_image_alt">
                                        </div>
                                        <!-- End Image alt -->

                                        <!-- Image title -->
                                        <div class="form-group">
                                            <label>Image title</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.short_image_title">
                                        </div>
                                        <!-- End Image title -->
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Short Image -->

                    <!-- Nav Video -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavVideo" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('Video')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseNavVideo" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavVideo">Video
                                        <span id="iconToggleVideo" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavVideo" 
                                        class="collapse" 
                                        aria-labelledby="NavVideo" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        
                                        <!-- Video -->
                                        <div class="form-group">
                                            <label>Video</label>

                                            <video v-if="row.video_preview" controls class="mb-2 custom-video" width="100%">
                                                <source :src="row.video_preview" type="video/mp4">
                                                Your browser does not support the video tag.
                                            </video>
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onVideoChange"
                                                accept="video/*">
                                        </div>
                                        <!-- Video -->

                                        <!-- Video Link -->
                                        <div class="form-group">
                                            <label>Video Link</label>
                                            <textarea type="text" 
                                                class="form-control"
                                                v-model="row.video_link" placeholder="Link or Script"></textarea>
                                        </div>
                                        <!-- End Video Link -->

                                        <!-- Video alt -->
                                        <div class="form-group">
                                            <label>Video alt</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.video_alt">
                                        </div>
                                        <!-- End Video alt -->

                                        <!-- Video title -->
                                        <div class="form-group">
                                            <label>Video title</label>
                                            <input type="text" 
                                                class="form-control"
                                                v-model="row.video_title">
                                        </div>
                                        <!-- End Video title -->
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Video -->

                    <!-- Nav Upload PDF -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavUploadPDF" class="card-header">
                                    <h2 class="h4 card-header-title"
                                        @click="collapseToggle('UploadPDF')"  
                                        aria-expanded="false" 
                                        aria-controls="collapseNavUploadPDF" 
                                        data-toggle="collapse" 
                                        data-target="#collapseNavUploadPDF">Upload PDF
                                        <span id="iconToggleUploadPDF" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavUploadPDF" 
                                        class="collapse" 
                                        aria-labelledby="NavUploadPDF" 
                                        data-parent="#accordionNav">
                                    
                                    <div class="col-12 pt-3">
                                        
                                        <!-- Image -->
                                        <div class="form-group">
                                            <p>
                                                <a :href="row.pdf_preview">Preview</a>
                                            </p>
                                            <input type="file" 
                                                class="form-control" 
                                                ref="myDropify" 
                                                v-on:change="onPDFChange"
                                                accept="application/pdf">
                                        </div>
                                        <!-- Image -->
                                    
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Upload PDF -->

                    <!-- Linked FAQs -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavFaqs" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Faqs')"
                                        aria-expanded="false" 
                                        aria-controls="collapseNavFaqs" 
                                        data-toggle="collapse"
                                        data-target="#collapseNavFaqs">Linked FAQs
                                        <span id="iconToggleFaqs" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow pull-right black">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavFaqs" 
                                    class="collapse" 
                                    aria-labelledby="NavFaqs" 
                                    data-parent="#accordionNav">
                                    <div class="col-12 pt-3">
                                        <p class="text-muted small">Order follows selection order in the list.</p>
                                        <div class="form-group">
                                            <div v-if="faqsLoading" class="text-center">
                                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                                    role="status" 
                                                    aria-hidden="true">
                                                </span>
                                            </div>
                                            <multiselect v-if="!faqsLoading"
                                                id="multiselect-faqs-packages-edit"
                                                v-model="row.faqsValues" 
                                                :options="faqsOptions" 
                                                :multiple="true"
                                                :close-on-select="false" 
                                                :clear-on-select="false" 
                                                :hide-selected="true" 
                                                :preserve-search="true" 
                                                :taggable="false"
                                                label="title"
                                                track-by="id"
                                                placeholder="Search and select FAQs"
                                                :preselect-first="false">
                                            </multiselect>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Linked FAQs -->

                    <!-- Nav Status -->
                    <div class="card mt-5">
                        <div class="card-body">
                            <div id="accordionNav" class="accordion">
                                <div id="NavStatus" class="card-header">
                                    <h2 class="h4 card-header-title" 
                                        @click="collapseToggle('Status')"
                                        aria-expanded="false" 
                                        aria-controls="collapseNavStatus" 
                                        data-toggle="collapse"
                                        data-target="#collapseNavStatus">Status & Visibility
                                        <span id="iconToggleStatus" 
                                            class="ti-angle-up u-sidebar-nav-menu__item-arrow black pull-right">
                                        </span>
                                    </h2>
                                </div>
                                <div id="collapseNavStatus" 
                                        class="collapse" 
                                        aria-labelledby="NavStatus" 
                                        data-parent="#accordionNav">
                                        
                                    <div class="col-12 pt-3">
                                        
                                        <!-- Status -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch1" 
                                                    :checked="row.status"
                                                    @click="onStatus">
                                                <label class="custom-control-label" 
                                                    for="customSwitch1"
                                                    v-html="(row.status) ? 'Active' : 'Inactive'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Status -->

                                        <!-- View In Home -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch2" 
                                                    :checked="row.view_in_home"
                                                    @click="onHome">
                                                <label class="custom-control-label" 
                                                    for="customSwitch2"
                                                    v-html="(row.view_in_home) 
                                                        ? 'Show In Home' : 'Hide In Home'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End View In Home -->

                                        <!-- View In Destination Home -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch3" 
                                                    :checked="row.view_in_destination_home"
                                                    @click="onDestination">
                                                <label class="custom-control-label" 
                                                    for="customSwitch3"
                                                    v-html="(row.view_in_destination_home) 
                                                        ? 'Show In Destination Home' 
                                                        : 'Hide In Destination Home'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End View In Destination Home -->


                                        <!-- Is combined tour -->
                                        <div class="form-group">
                                            <div class="custom-control custom-switch mb-2">
                                                <input type="checkbox" 
                                                    class="custom-control-input" 
                                                    id="customSwitch4" 
                                                    :checked="row.is_combined_tour"
                                                    @click="onCombindTour">
                                                <label class="custom-control-label" 
                                                    for="customSwitch4"
                                                    v-html="(row.is_combined_tour) 
                                                        ? 'Is Combined Tour' 
                                                        : 'Not Combined Tour'">
                                                </label>
                                            </div>
                                        </div>
                                        <!-- End Is combined tour -->


                                        <!-- View in menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch5" 
                                                        :checked="row.view_in_menu"
                                                        @click="onViewInMenu">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch5"
                                                        v-html="(row.view_in_menu) 
                                                            ? 'Show In Menu' 
                                                            : 'Hide In Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in menu -->

                                            <!-- Menu Order -->
                                            <div class="no-rpadding">
                                                <div class="form-group">
                                                    <input class="form-control"
                                                            v-bind:style="{display: orderDisplay}"
                                                            placeholder="Order In Menu" 
                                                            id="inputText8" 
                                                            type="number"
                                                            min="0" 
                                                            v-model.number="row.menu_order">
                                                </div>
                                            </div>
                                            <!-- End Menu Order -->

                                            <!-- View in sub menu -->
                                            <div class="form-group">
                                                <div class="custom-control custom-switch mb-2">
                                                    <input type="checkbox" 
                                                        class="custom-control-input" 
                                                        id="customSwitch6" 
                                                        :checked="row.view_in_sub_menu"
                                                        @click="onViewInSubMenu">
                                                    <label class="custom-control-label" 
                                                        for="customSwitch6"
                                                        v-html="(row.view_in_sub_menu) 
                                                            ? 'Show In Sub Menu' 
                                                            : 'Hide In Sub Menu'">
                                                    </label>
                                                </div>
                                            </div>
                                            <!-- End View in menu -->
                                            <!-- Menu select -->
                                            <div class="col-12 pt-3">
                                                <div class="form-group">
                                                    <div v-if="menuLoading" class="text-center">
                                                        <span class="spinner-grow spinner-grow-sm mr-1" 
                                                            role="status" 
                                                            aria-hidden="true">
                                                        </span>
                                                    </div>
                                                    <select v-bind:style="{display: inputDisplay}" class="form-control custom-select"
                                                        v-if="!menuLoading" 
                                                        v-model="row.menu_id">
                                                        <option value="">Select Menu</option>
                                                        <option v-for="(menu, index) in menus" 
                                                                :key="index"
                                                                
                                                                :value="menu.id">
                                                                {{ menu.title }}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                            <!-- End menu select -->

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Nav Status -->

                </div>
                <!-- ******* End SideNav ******** -->


                </div>
            </div>
            <!-- End Content -->

                <!-- Buttons -->
                <div class="col-md-12 row">
                    <div class="form-group mr-2">
                        <button class="btn btn-primary" :disabled="btnLoading || uploading">
                            <span v-if="btnLoading || uploading">
                                <span class="spinner-grow spinner-grow-sm mr-1" 
                                    role="status" 
                                    aria-hidden="true">
                                </span>Loading...
                            </span>
                            <span v-if="!btnLoading && !uploading" class="ti-check-box"></span>
                            <span v-if="!btnLoading && !uploading"> Update Package</span>
                        </button>
                    </div>

                    <div class="form-group">
                        <button type="button" class="btn btn-danger" 
                            :disabled="btnLoading || uploading" 
                            @click="cancel">
                            <span class="ti-close"></span>
                            <span> Cancel </span>
                        </button>
                    </div>
                </div>
                <!-- End Buttons -->


            </form>
        </div>

                <Footer></Footer>
            </div>
        </main>
        <!-- End Main -->
        
    </div>
</template>

<script>
    import Header from '../layouts/Header.vue';
    import Navigation from '../layouts/Navigation';
    import Footer from '../layouts/Footer.vue';
    import Multiselect from 'vue-multiselect';
    import Editor from '@tinymce/tinymce-vue';
    import iziToast from 'izitoast';

    export default {
        name: 'Edit',
        components: {
            Header,
            Navigation,
            Footer,
            Editor,
            Multiselect
        },
        data(){
            return {
                //
                auth: {
                    role: '',
                    access_token: '',
                },
                row: {
                    // meta
                    meta_title: '',
                    meta_keywords: '',
                    meta_description: '',

                    //sitemap
                    sitemap_freq: 'monthly',
                    sitemap_priority: 0.5,

                    // package
                    slug: '',
                    title: '',
                    short_title: '',
                    popular: '',
                    start_price: '',
                    have_discount: 0,
                    discount: '',
                    stars: '',
                    stars_no: '',
                    sort: 0,
                    tour_type: '',
                    duration: '',
                    sort_duration: 0,
                    visited_locations: '',
                    Inclusion: '',
                    exclusion: '',
                    price_note: '',
                    run_dates: '',
                    guide_lang: '',
                    short_body: '',
                    body: '',
                    free_photo_session: 0,
                    video_link: '',

                    // prices
                    price_key: 0,
                    prices: [],
                    price_names: [],
                    // items
                    price_items: [],
                    price_item_key: [],
                    price_item_value: [],
                    price_item_body: [],

                    // itineraries
                    itinerarie_key: 0,
                    itineraries: [],
                    itinerarie_names: [],
                    itinerarie_sort: [],
                    itinerarie_body: [],
                    itinerarie_meals: [],
                    itinerarie_accomodation: [],
                    media_preview: [],
                    media_base64: [],
                    media_url: [],
                    media_alt: [],
                    media_title: [],
                    media_file_type: [],

                    // galleries
                    galleries: [],
                    gallery_key: 0,
                    gallery_image_preview: [],
                    gallery_image_base64: [],
                    gallery_image_alt: [],
                    gallery_image_title: [],

                    // videos
                    videos: [],
                    videos_key: 0,
                    videos_preview: [],
                    videos_base64: [],
                    videos_alt: [],
                    videos_title: [],
                    videos_link: [],


                    // trip information
                    trip_information_key: 0,
                    tripInformations: [],
                    trip_information_names: [],
                    trip_information_orders: [],
                    trip_information_body: [],

                    // destination
                    destination_id: '',

                    // category
                    category_id: '',

                    // packageType
                    package_type_id: '',

                    // multiple destinations
                    destinationsValues: [],

                    // multiple accommodations
                    accommodationsValues: [],

                    // multiple hotels
                    hotelsValues: [],

                    // multiple package related
                    packageRelatedValues: [],

                    // multiple tags
                    tagsValues: [],

                    // multiple icons
                    iconsValues: [],

                    // image
                    image_preview: '',
                    image_base64: '',
                    image_alt: '',
                    image_title: '',

                    // mobile image
                    mobile_image_preview: '',
                    mobile_image_base64: '',
                    mobile_image_alt: '',
                    mobile_image_title: '',

                    // short image
                    short_image_preview: '',
                    short_image_base64: '',
                    short_image_alt: '',
                    short_image_title: '',

                    //video
                    video_preview: '',
                    video_base64: '',
                    video_alt: '',
                    video_title: '',

                    // upload pdf
                    pdf_preview: '',
                    pdf_base64: '',

                    // status & visibility
                    status: 1,
                    view_in_home: 0,
                    view_in_destination_home: 0,
                    is_combined_tour: 0,
                    view_in_menu: 0,
                    view_in_sub_menu: 0,
                    menu_id: '',
                    menu_order: '',
                    faqsValues: [],

                    // more media
                    more_media: {}, // key: itinerary index, value: array of media objects
                    more_media_temp: {}, // for holding temp input before adding
                    more_media_key: {}, // key: itinerary index, value: number of more_media forms
                },
                editor: {
                    api_key: window.editor_apiKey,
                    menubar: window.editor_menubar,
                    plugins:[window.editor_plugins],
                    external_plugins: window.editor_external_plugins,
                    toolbar: window.editor_toolbar,
                },

                // destinations
                destinations: [],
                destinationLoading: true,

                // category
                categories: [],
                categoryLoading: true,

                // packageTypes
                packageTypes: [],
                packageTypesLoading: true,

                // multiple destinations
                destinationsOptions: [],
                destinationsLoading: true,

                // multiple accommodations
                accommodationsOptions: [],
                accommodationsLoading: true,

                // multiple hotels
                hotelsOptions: [],
                hotelsLoading: true,

                // multiple packageRelated
                packageRelatedOptions: [],
                packageRelatedLoading: true,

                // multiple tags
                tagsOptions: [],
                tagsLoading: true,

                // multiple icons
                iconsOptions: [],
                iconsLoading: true,

                // length
                prices_items_length: [],
                itineraries_items_length: [],

                // btn
                pgLoading: true,
                btnLoading: false,

                // Tenants
                tenant_id: 0,
                tenant_name: '',
                refs: 'packages',

                // menu
                menus: [],
                menuLoading: true,
                // input disabled
                inputDisplay: 'none',
                orderDisplay: 'none',
                chunkSize: 30 * 1024 * 1024,
                totalChunks: 0,
                uniqueIdentifier: '',
                uploading: false,
                uploadProgress: 0,
                uploadMessage: '',

                faqsOptions: [],
                faqsLoading: true,
            }
        },
        mounted() {},
        computed: {},
        created() {
            // AccessToken & Role
            if(localStorage.getItem('role')) {
                this.auth.role = localStorage.getItem('role');
            }
            if(localStorage.getItem('access_token')) {
                this.auth.access_token = localStorage.getItem('access_token');
            }

            // Tenants
            if(localStorage.getItem('tenant_id')) {
                this.tenant_id = localStorage.getItem('tenant_id');
            }
            if(localStorage.getItem('tenant_name')) {
                this.tenant_name = localStorage.getItem('tenant_name');
            }

            this.fetchFaqs().then(() => { this.fetchRow(); });
        },
        methods: {
            
            fetchFaqs(){
                this.faqsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/faqs',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 200,
                    },
                };
                return this.axios(options)
                    .then(res => {
                        this.faqsOptions = res.data.rows || [];
                    })
                    .catch(() => { this.faqsOptions = []; })
                    .finally(() => { this.faqsLoading = false; });
            },

            hydrateFaqsFromRow(row) {
                this.row.faqsValues = [];
                if (!row.faqs || !row.faqs.length) { return; }
                const f = row.faqs;
                if (typeof f[0] === 'object' && f[0] !== null && f[0].id !== undefined) {
                    this.row.faqsValues = f.slice();
                } else {
                    this.row.faqsValues = f.map(id => this.faqsOptions.find(o => o.id === id)).filter(Boolean);
                }
            },

            // fetch Row
            fetchRow() {
                this.pgLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                    method: 'GET',
                    data: {},
                    params: {},
                }
                this.axios(options)
                    .then(res => {
                    this.pgLoading = false;

                    // tenant
                    this.tenant_id = res.data.row.tenant_id;
                    this.tenant_name = res.data.row.tenant_name;

                    // meta
                    this.row.meta_title = (res.data.row.meta) ? res.data.row.meta.meta_title : null;
                    this.row.meta_keywords = (res.data.row.meta) ? res.data.row.meta.meta_keywords : null;
                    this.row.meta_description = (res.data.row.meta) ? res.data.row.meta.meta_description : null;

                    //sitemap
                    this.row.sitemap_freq = res.data.row.sitemap_freq; 
                    this.row.sitemap_priority = res.data.row.sitemap_priority;

                    // row
                    this.row.slug = res.data.row.slug;
                    this.row.title = res.data.row.title;
                    this.row.short_title = res.data.row.short_title;
                    this.row.popular = res.data.row.popular;
                    this.row.start_price = res.data.row.start_price;
                    this.row.have_discount = res.data.row.have_discount;
                    this.row.discount = res.data.row.discount;
                    this.row.stars = res.data.row.stars;
                    this.row.stars_no = res.data.row.stars_no;
                    this.row.sort = res.data.row.sort;
                    this.row.tour_type = res.data.row.tour_type;
                    this.row.video_link = res.data.row.video_link;
                    this.row.duration = res.data.row.duration;
                    this.row.sort_duration = res.data.row.sort_duration;
                    this.row.inclusion = res.data.row.inclusion;
                    this.row.exclusion = res.data.row.exclusion;
                    this.row.price_note = res.data.row.price_note;
                    this.row.run_dates = res.data.row.run_dates;
                    this.row.guide_lang = res.data.row.guide_lang;
                    this.row.visited_locations = res.data.row.visited_locations;
                    this.row.short_body = res.data.row.short_body;
                    this.row.body = res.data.row.body;
                    this.row.free_photo_session = res.data.row.free_photo_session;

                    
                    // prices
                    this.row.price_key = res.data.row.prices.length;
                    if(res.data.row.prices) {
                        for(let i = 1; i <= this.row.price_key; i++) {
                            let x = i-1;
                            this.row.price_names[i] = res.data.row.prices[x].name;
                            // get items
                            this.prices_items_length[x] = res.data.row.prices[x].items.length;
                            for( let y = 1; y <= res.data.row.prices[x].items.length; y++) {
                                let z = y-1;
                                this.row.price_item_value[i+'_'+y] 
                                        = res.data.row.prices[x].items[z].price_value;
                                this.row.price_item_body[i+'_'+y] 
                                        = res.data.row.prices[x].items[z].body;
                            }
                        }
                    }

                    // itineraries
                    this.row.itinerarie_key = res.data.row.itineraries.length;
                    if(res.data.row.itineraries) {
                        for(let m = 1; m <= this.row.itinerarie_key; m++) {
                            let w = m-1;
                            this.row.itinerarie_names[m] = res.data.row.itineraries[w].title;
                            this.row.itinerarie_sort[m] = res.data.row.itineraries[w].sort;
                            this.row.itinerarie_body[m] = res.data.row.itineraries[w].body;
                            this.row.itinerarie_meals[m] = res.data.row.itineraries[w].meals;
                            this.row.itinerarie_accomodation[m] = res.data.row.itineraries[w].accomodation;
                            this.row.media_preview[m] = res.data.row.itineraries[w].media;
                            this.row.media_base64[m] = res.data.row.itineraries[w].media;
                            this.row.media_url[m] = res.data.row.itineraries[w].media_url;
                            this.row.media_alt[m] = res.data.row.itineraries[w].media_alt;
                            this.row.media_title[m] = res.data.row.itineraries[w].media_title;
                            this.row.more_media[m] = res.data.row.itineraries[w].more_media || [];
                            this.row.more_media_key[m] = (this.row.more_media[m] ? this.row.more_media[m].length : 0);
                        }
                    }

                    // tripINformation
                    this.row.trip_information_key = res.data.row.TripInformation.length;
                    if(res.data.row.TripInformation) {
                        for(let m = 1; m <= this.row.trip_information_key; m++) {
                            let w = m-1;
                            this.row.trip_information_names[m] = res.data.row.TripInformation[w].title;
                            this.row.trip_information_orders[m] = res.data.row.TripInformation[w].order;
                            this.row.trip_information_body[m] = res.data.row.TripInformation[w].body;
                        }
                    }

                    // galleries
                    this.row.gallery_key = res.data.row.galleries.length;
                    if(res.data.row.galleries) {
                        for(let g = 1; g <= this.row.gallery_key; g++) {
                            let q = g-1;
                            this.row.gallery_image_preview[g] = res.data.row.galleries[q].image_url;
                            this.row.gallery_image_base64[g] = res.data.row.galleries[q].image_url;
                            this.row.gallery_image_alt[g] = res.data.row.galleries[q].image_alt;
                            this.row.gallery_image_title[g] = res.data.row.galleries[q].image_title;
                        }
                    }

                    // videos
                    this.row.videos_key = res.data.row.videos.length;
                    if(res.data.row.videos) {
                        for(let vs = 1; vs <= this.row.videos_key; vs++) {
                            let v = vs-1;
                            this.row.videos_preview[vs] = res.data.row.videos[v].image_url;
                            this.row.videos_base64[vs] = res.data.row.videos[v].image_url;
                            this.row.videos_alt[vs] = res.data.row.videos[v].image_alt;
                            this.row.videos_title[vs] = res.data.row.videos[v].image_title;
                            this.row.videos_link[vs] = res.data.row.videos[v].videos_link;
                        }
                    }


                    // navbar
                    this.row.destination_id = (res.data.row.destination) ? res.data.row.destination.id : null;
                    this.row.category_id = (res.data.row.category) ? res.data.row.category.id : null;
                    this.row.package_type_id = (res.data.row.packageType) ? res.data.row.packageType.id : null;
                    this.row.destinationsValues = res.data.row.destinations;
                    this.row.accommodationsValues = res.data.row.accommodations;
                    this.row.hotelsValues = res.data.row.hotels;
                    this.row.packageRelatedValues = res.data.row.related_packages;
                    this.row.tagsValues = res.data.row.tags;
                    this.row.iconsValues = res.data.row.icons;

                    // images
                    this.row.image_preview = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_base64 = (res.data.row.image) ? res.data.row.image.image_url : null;
                    this.row.image_alt = (res.data.row.image ) ? res.data.row.image.image_alt : null;
                    this.row.image_title = (res.data.row.image ) ? res.data.row.image.image_title : null;

                    // mobile image
                    this.row.mobile_image_preview = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_url : null;
                    this.row.mobile_image_base64 = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_url : null;
                    this.row.mobile_image_alt = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_alt : null;
                    this.row.mobile_image_title = (res.data.row.mobile_image) ? res.data.row.mobile_image.image_title : null;

                    this.row.short_image_preview = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_url 
                                                    : null;
                    this.row.short_image_base64 = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_url 
                                                    : null;
                    this.row.short_image_alt = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_alt 
                                                    : null;
                    this.row.short_image_title = (res.data.row.short_image) 
                                                    ? res.data.row.short_image.image_title 
                                                    : null;

                    //video
                    this.row.video_preview = (res.data.row.video) 
                                                    ? res.data.row.video.image_url 
                                                    : null;
                    this.row.video_base64 = (res.data.row.video) 
                                                    ? res.data.row.video.image_url 
                                                    : null;
                    this.row.video_alt = (res.data.row.video) 
                                                    ? res.data.row.video.image_alt 
                                                    : null;
                    this.row.video_title = (res.data.row.video) 
                                                    ? res.data.row.video.image_title 
                                                    : null;

                    // pdf
                    this.row.pdf_preview = (res.data.row.pdf) 
                                                    ? res.data.row.pdf.image_url 
                                                    : null;
                    this.row.pdf_base64 = (res.data.row.pdf) 
                                                    ? res.data.row.pdf.image_url 
                                                    : null;

                    // status & visibility
                    this.row.status = res.data.row.status;
                    this.row.view_in_home = res.data.row.view_in_home;
                    this.row.view_in_destination_home = res.data.row.view_in_destination_home;
                    this.row.is_combined_tour = res.data.row.is_combined_tour;

                    this.row.view_in_menu = res.data.row.view_in_menu;
                    this.row.menu_order = res.data.row.menu_order;
                    this.row.view_in_sub_menu = res.data.row.view_in_sub_menu;
                    this.row.menu_id = res.data.row.menu_id;
                    this.hydrateFaqsFromRow(res.data.row);

                    if (res.data.row.view_in_menu == 1) {
                        this.orderDisplay = 'block';
                    } else {
                        this.orderDisplay = 'none';
                    }

                    if (res.data.row.view_in_sub_menu == 1) {
                        this.inputDisplay = 'block';
                    } else {
                        this.inputDisplay = 'none';
                    }  



                    this.fetchDestination(); // call next func

                    })
                    .catch(() => {})
                    .finally(() => {});
            },

            // fetchDestination
            fetchDestination() {
                this.destinationLoading = true;
                this.destinationsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/regions',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.destinationLoading = false;
                    this.destinations = res.data.rows;
                    
                    this.fetchCategories(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchCategories
            fetchCategories() {
                this.categoryLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/categories',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        is_cruise: false,
                        is_article: false,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.categoryLoading = false;
                    this.categories = res.data.rows;
                    
                    this.fetchPackageTypes(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchPackageTypes
            fetchPackageTypes(){
                this.packageTypesLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/packagetypes',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        parent_id: 'null',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.packageTypesLoading = false;
                    this.packageTypes = res.data.rows;

                    this.fetchMultipleDestinations(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            fetchMultipleDestinations() {
                this.destinationsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/destinations',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.destinationsLoading = false;
                    this.destinationsOptions = res.data.destinations;
                    
                    this.fetchMultipleAccommodations(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleAccommodations
            fetchMultipleAccommodations(){
                this.accommodationsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/accommodations',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.accommodationsLoading = false;
                    this.accommodationsOptions = res.data.accommodations;

                    this.fetchMultipleHotels(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleAccommodations
            fetchMultipleHotels(){
                this.hotelsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/hotels',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.hotelsLoading = false;
                    this.hotelsOptions = res.data.hotels;

                    this.fetchMultiplepackageRelated(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultiplepackageRelated
            fetchMultiplepackageRelated(){
                this.packageRelatedLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/packages',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        except_id: this.$route.params.id,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.packageRelatedLoading = false;
                    this.packageRelatedOptions = res.data.packages;

                    this.fetchMultipleTags(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleTags
            fetchMultipleTags(){
                this.tagsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/tags',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.tagsLoading = false;
                    this.tagsOptions = res.data.tags;

                    this.fetchMultipleIcons(); // call next function
                })
                .catch(() => {})
                .finally(() => {});
            },

            // fetchMultipleIcons
            fetchMultipleIcons(){
                this.iconsLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/icons',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        status: 'active',
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.iconsLoading = false;
                    this.iconsOptions = res.data.icons;
                    //
                })
                .catch(() => {})
                .finally(() => {});
            },



            // edit Row
            editRow(){
                if(this.tenant_id == 0) {
                    
                    iziToast.warning({
                        icon: 'ti-alert',
                        title: 'Wow-man,',
                        message: 'No tenany selected.'
                    });

                } else {

                    if (this.row.status == false) {
                        this.row.status = 0;
                    } else {
                        this.row.status = 1;
                    }
                    if (this.row.view_in_home == false) {
                        this.row.view_in_home = 0;
                    } else {
                        this.row.view_in_home = 1;
                    }

                    if (this.row.view_in_menu == false) {
                        this.row.view_in_menu = 0;
                    } else {
                        this.row.view_in_menu = 1;
                    }

                    if (this.row.view_in_sub_menu == false) {
                        this.row.view_in_sub_menu = 0;
                    } else {
                        this.row.view_in_sub_menu = 1;
                    }

                    if (this.row.view_in_destination_home == false) {
                        this.row.view_in_destination_home = 0;
                    } else {
                        this.row.view_in_destination_home = 1;
                    }
                    
                    if (this.row.is_combined_tour == false) {
                        this.row.is_combined_tour = 0;
                    } else {
                        this.row.is_combined_tour = 1;
                    }

                    if(this.row.have_discount == false) {
                        this.row.have_discount = 0;
                    } else {
                        this.row.have_discount = 1;
                    }

                    if(this.row.free_photo_session == false) {
                        this.row.free_photo_session = 0;
                    } else {
                        this.row.free_photo_session = 1;
                    }

                    this.btnLoading = true;
                    this.axios.defaults.headers.common = {
                        'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                        'Authorization': `Bearer ` + this.auth.access_token,
                    };

                    // prices
                    // for( let i = 1; i < this.row.price_names.length; i++ ) {
                    //         for( let x = 1; x <= 10; x++) {
                    //         let item_value = this.row.price_item_value[i+'_'+x];
                    //         let item_body  = this.row.price_item_body[i+'_'+x];
                    //         if(item_value) {
                    //             this.row.price_items[x] = {
                    //                 'item_value' : item_value,
                    //                 'item_body'  : item_body
                    //             }
                    //         }
                    //     }
                    //     this.row.prices[i] = {
                    //         'price_name' : this.row.price_names[i],
                    //         'items'      : this.row.price_items
                    //     }
                    //     this.row.price_items = []; // clear array
                    // }

                    // itineraries
                    for( let i = 1; i < this.row.itinerarie_names.length; i++ ) {
                        if (this.row.itinerarie_names[i] != "") {
                            this.row.itineraries[i] = {
                                'itinerarie_name' : this.row.itinerarie_names[i],
                                'itinerarie_sort' : this.row.itinerarie_sort[i],
                                'itinerarie_body' : this.row.itinerarie_body[i],
                                'itinerarie_meals' : this.row.itinerarie_meals[i],
                                'itinerarie_accomodation' : this.row.itinerarie_accomodation[i],
                                'media_base64': this.row.media_base64[i] || '',
                                'media_url': this.row.media_url[i] || '',
                                'media_alt': this.row.media_alt[i] || '',
                                'media_title': this.row.media_title[i] || '',
                                'more_media': this.row.more_media[i] || []
                            }
                        }
                    }

                    // tripInformation
                    for( let i = 1; i < this.row.trip_information_names.length; i++ ) {
                        if (this.row.trip_information_names[i] != "") {
                            this.row.tripInformations[i] = {
                                'title'  : this.row.trip_information_names[i],
                                'order' : this.row.trip_information_orders[i],
                                'body'  : this.row.trip_information_body[i]
                            }
                        }
                    }

                    // galleries
                    for( let i = 1; i < this.row.gallery_image_base64.length; i++ ) {
                        this.row.galleries[i] = {
                            'gallery_image_base64' : this.row.gallery_image_base64[i],
                            'gallery_image_alt' : this.row.gallery_image_alt[i],
                            'gallery_image_title' : this.row.gallery_image_title[i]
                        }
                    }

                    // videos
                    // for( let i = 1; i < this.row.videos_base64.length; i++ ) {
                    //     this.row.videos[i] = {
                    //         'videos_base64' : this.row.videos_base64[i],
                    //         'videos_alt' : this.row.videos_alt[i],
                    //         'videos_title' : this.row.videos_title[i],
                    //         'videos_link'  : this.row.videos_link[i]
                    //     }
                    // }
                    if (this.row.videos_key > 0) {
                        for (let i = 1; i <= this.row.videos_key; i++) {
                            // Only add to videos array if there's either a base64 or a link
                            if (this.row.videos_base64[i] || this.row.videos_link[i]) {
                                this.row.videos[i] = {
                                    'videos_base64': this.row.videos_base64[i] || '', // Use empty string if undefined
                                    'videos_alt': this.row.videos_alt[i] || '',
                                    'videos_title': this.row.videos_title[i] || '',
                                    'videos_link': this.row.videos_link[i] || ''
                                }
                            }
                        }
                    }

                    const config = { headers: { 'Content-Type': 'multipart/form-data' }};  
                    const options = {
                        url: window.baseURL+'/'+this.refs+'/'+this.$route.params.id,
                        method: 'PUT',
                        data: {
                            tenant_id: this.tenant_id,
                            // meta
                            meta_title: this.row.meta_title,
                            meta_keywords: this.row.meta_keywords,
                            meta_description: this.row.meta_description,

                            //sitemap
                            sitemap_freq: this.row.sitemap_freq,
                            sitemap_priority:   this.row.sitemap_priority,

                            // package
                            title: this.row.title,
                            slug: this.row.slug,
                            short_title: this.row.short_title,
                            popular: this.row.popular,
                            start_price: this.row.start_price,
                            have_discount: this.row.have_discount,
                            discount: this.row.discount,
                            stars: this.row.stars,
                            stars_no: this.row.stars_no,
                            sort: this.row.sort,
                            tour_type: this.row.tour_type,
                            video_link: this.row.video_link,
                            duration: this.row.duration,
                            sort_duration: this.row.sort_duration,
                            visited_locations: this.row.visited_locations,
                            inclusion: this.row.inclusion,
                            exclusion: this.row.exclusion,
                            price_note: this.row.price_note,
                            run_dates: this.row.run_dates,
                            guide_lang: this.row.guide_lang,
                            short_body: this.row.short_body,
                            body: this.row.body,
                            free_photo_session: this.row.free_photo_session,

                            // prices
                            prices: this.row.prices,

                            // itineraries
                            itineraries: this.row.itineraries,

                            // galleries
                            galleries: this.row.galleries,

                            // videos
                            videos: this.row.videos,

                            // trip information
                            TripInformation: this.row.tripInformations,

                            // navbar
                            destination_id: this.row.destination_id,
                            category_id: this.row.category_id,
                            package_type_id: this.row.package_type_id,
                            destinations: this.row.destinationsValues,
                            accommodations: this.row.accommodationsValues,
                            hotels: this.row.hotelsValues,
                            related_packages: this.row.packageRelatedValues,
                            tags: this.row.tagsValues,
                            icons: this.row.iconsValues,

                            // image
                            image_base64: this.row.image_base64,
                            image_alt: this.row.image_alt,
                            image_title: this.row.image_title,

                            // mobile image 
                            mobile_image_base64: this.row.mobile_image_base64,
                            mobile_image_alt: this.row.mobile_image_alt,
                            mobile_image_title: this.row.mobile_image_title,

                            // short image
                            short_image_base64: this.row.short_image_base64,
                            short_image_alt: this.row.short_image_alt,
                            short_image_title: this.row.short_image_title,

                            // video
                            video_base64: this.row.video_base64,
                            video_alt: this.row.video_alt,
                            video_title: this.row.video_title,

                            // upload pdf
                            pdf_base64: this.row.pdf_base64,

                            // status & visibility
                            status: this.row.status,
                            view_in_home: this.row.view_in_home,
                            view_in_destination_home: this.row.view_in_destination_home,
                            is_combined_tour: this.row.is_combined_tour,
                            view_in_menu: this.row.view_in_menu,
                            menu_order: this.row.menu_order,
                            view_in_sub_menu: this.row.view_in_sub_menu,
                            menu_id: this.row.menu_id,
                            faqs: (this.row.faqsValues || []).map(f => f.id),
                        }
                    }
                    this.axios(options, config)
                        .then(() => {
                            this.btnLoading = false;
                            iziToast.success({
                                icon: 'ti-check',
                                title: 'Great job,',
                                message: 'Item Updated Successfully.',
                            });
                            this.$router.push({ name: this.refs });
                        })
                        .catch(err => {
                            // 403 Forbidden
                            if(err.response && err.response.status == 401) {
                                this.removeLocalStorage();
                                this.$router.push({ name: 'login' });
                            } else if(err.response && err.response.status == 403) {
                                this.$router.push({ name: 'forbidden' });
                            } else {
                                this.btnLoading = false;
                                iziToast.warning({
                                    icon: 'ti-alert',
                                    title: 'Wow-man,',
                                    message: err.response.data.message
                                });
                            }
                        })
                        .finally(() => {})
                }
            },

            // remove localStorage
            removeLocalStorage() {
                localStorage.removeItem('access_token');
                localStorage.removeItem('user_image');
                localStorage.removeItem('user_name');
                localStorage.removeItem('user_id');
                localStorage.removeItem('role');
                localStorage.removeItem('tenant_id');
            },

            haveDiscount() {
                if(this.row.have_discount)
                    this.row.have_discount = 0;
                else
                    this.row.have_discount = 1;
            },
            haveFreePhotoSession() {
                if(this.row.free_photo_session)
                    this.row.free_photo_session = 0;
                else
                    this.row.free_photo_session = 1;
            },

            // items add more
            opnFrm() {
                this.row.price_key++;
                this.row.price_item_key[this.row.price_key] = 0;
            },
            removeOption(i) {
                document.querySelector('#frm_'+i).remove();
                this.row.price_names[i] = '';
                this.row.price_item_key[i] = '';
                // this.row.price_key--; // makes issue

                // clear all sub
                let n = [1,2,3,4,5,6,7,8,9,10];
                n.forEach(x => {
                    this.row.price_item_value[i+'_'+x] = '';
                    this.row.price_item_body[i+'_'+x] = '';
                });
            },
            opnSub(i) {
                this.row.price_item_key[i] += 1;
                document.querySelector('#sub_'+i+'_'+this.row.price_item_key[i]).classList.remove('hidden');
            },
            removeSubOption(i,x) {
                document.querySelector('#sub_'+i+'_'+x).classList.add('hidden');
                this.row.price_item_value[i+'_'+x] = '';
                this.row.price_item_body[i+'_'+x] = '';
                this.row.price_item_key[i] -= 1;
            },

            // itineraries add more
            opnFrm2() {
                this.row.itinerarie_key++;
                this.row.itinerarie_item_key[this.row.itinerarie_key] = 0;
            },
            removeOption2(i) {
                document.querySelector('#frm2_'+i).remove();
                this.row.itinerarie_names[i] = '';
                this.row.itinerarie_sort[i] = '';
                this.row.itinerarie_body[i] = '';
                this.row.itinerarie_meals[i] = '';
                this.row.itinerarie_accomodation[i] = '';
                this.row.media_preview[i] = '';
                this.row.media_base64[i] = '';
                this.row.media_url[i] = '';
                this.row.media_alt[i] = '';
                this.row.media_title[i] = '';
                // this.row.itinerarie_key--; // makes issue

                // clear all sub
                // let n = [1,2,3,4,5,6,7,8,9,10];
                // n.forEach(x => {
                //     this.row.itinerarie_item_title[i+'_'+x] = '';
                //     this.row.itinerarie_item_sort[i+'_'+x] = '';
                //     this.row.itinerarie_item_body[i+'_'+x] = '';
                // });
            },
            
            // items3 add more
            opnFrm3() {
                this.row.gallery_key++;
            },
            removeOption3(i) {
                document.querySelector('#frm3_'+i).remove();
                this.row.gallery_image_preview[i] = '';
                this.row.gallery_image_base64[i] = '';
                this.row.gallery_image_alt[i] = '';
                this.row.gallery_image_title[i] = '';
            },

            removeOption4(i) {
                document.querySelector('#frm4_'+i).remove();
                this.row.trip_information_names[i] = '';
                this.row.trip_information_orders[i] = '';
                this.row.trip_information_body[i] = '';
            },
            
            opnFrm4() {
                this.row.trip_information_key++;
            },

            opnFrm5() {
                this.row.videos_key++;
            },
            removeOption5(i) {
                document.querySelector('#frm5_'+i).remove();
                this.row.videos_preview[i] = '';
                this.row.videos_base64[i] = '';
                this.row.videos_alt[i] = '';
                this.row.videos_title[i] = '';
                this.row.videos_link[i] = '';
            },


            // Title
            onTitleChange() {
                // this.onSlugChange(this.row.title);
            },

            // on Paste
            onSlugPaste(){
                let str = this.row.slug;
                this.onSlugChange(str);
            },
            onSlugChange(str=''){
                if(!str) {
                    str = this.row.slug;
                }
                this.row.slug = str.replace(/\s+/g, '-');
            },


            // Upload images
            onGalleryImageChange(e, i){
                const file = e.target.files[0];
                this.row.gallery_image_preview[i] = URL.createObjectURL(file);
                this.createBase64Gallery(file, i);
            },
            createBase64Gallery(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.gallery_image_base64[i] = e.target.result;
                };
            },
            onVideosChange(e, i){
                const file = e.target.files[0];
                this.row.videos_preview[i] = URL.createObjectURL(file);
                this.createBase64Videos(file, i);
            },
            createBase64Videos(fileObject, i){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.videos_base64[i] = e.target.result;
                };
            },
            onImageChange(e){
                const file = e.target.files[0];
                this.row.image_preview = URL.createObjectURL(file);
                this.createBase64Image(file);
            },
            createBase64Image(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.image_base64 = e.target.result;
                };
            },
            // Upload Mobile Featured image
            onMobileImageChange(e){
                const file = e.target.files[0];
                this.row.mobile_image_preview = URL.createObjectURL(file);
                this.createBase64MobileImage(file);
            },
            createBase64MobileImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.mobile_image_base64 = e.target.result;
                };
            },
            onShortImageChange(e){
                const file = e.target.files[0];
                this.row.short_image_preview = URL.createObjectURL(file);
                this.createBase64ShortImage(file);
            },
            createBase64ShortImage(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.short_image_base64 = e.target.result;
                };
            },
            onVideoChange(e){
                const file = e.target.files[0];
                this.row.video_preview = URL.createObjectURL(file);
                this.createBase64Video(file);
            },
            createBase64Video(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.video_base64 = e.target.result;
                };
            },
            onPDFChange(e){
                const file = e.target.files[0];
                this.row.pdf_preview = URL.createObjectURL(file);
                this.createBase64PDF(file);
            },
            createBase64PDF(fileObject){
                const reader = new FileReader();
                reader.readAsDataURL(fileObject);
                reader.onload = e =>{
                    this.row.pdf_base64 = e.target.result;
                };
            },

            isImageFile(url, i) {
                if (url && url.startsWith('blob:')) {
                    // Use the stored MIME type if available
                    const type = this.row.media_file_type && this.row.media_file_type[i];
                    return type ? type.startsWith('image/') : false;
                }
                // Fallback to extension for real URLs
                const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp', '.svg'];
                const extension = this.getFileExtension(url);
                return imageExtensions.includes(extension);
            },

            isVideoFile(url, i) {
                if (url && url.startsWith('blob:')) {
                    const type = this.row.media_file_type && this.row.media_file_type[i];
                    return type ? type.startsWith('video/') : false;
                }
                const videoExtensions = ['.mp4', '.avi', '.mov', '.wmv', '.flv', '.webm', '.mkv', '.m4v'];
                const extension = this.getFileExtension(url);
                return videoExtensions.includes(extension);
            },
            getFileExtension(url) {
                if (!url) return '';
                
                const cleanUrl = url.split('?')[0].split('#')[0];
                const lastDotIndex = cleanUrl.lastIndexOf('.');
                if (lastDotIndex === -1) return '';
                
                return cleanUrl.substring(lastDotIndex).toLowerCase();
            },
            // Itinerarie Media Change
            async onItinerarieMediaChange(e, i) {
                const file = e.target.files[0];
                this.row.media_preview[i] = URL.createObjectURL(file);
                this.row.media_file_type = this.row.media_file_type || {};
                this.row.media_file_type[i] = file.type;

                this.totalChunks = Math.ceil(file.size / this.chunkSize);
                this.uniqueIdentifier = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${file.name.replace(/\.[^/.]+$/, "")}`;

                this.uploading = true;
                this.uploadProgress = 0;
                this.uploadMessage = 'Uploading...';

                for (let chunkNumber = 1; chunkNumber <= this.totalChunks; chunkNumber++) {
                    await this.uploadChunk(file, chunkNumber);
                    this.uploadProgress = Math.round((chunkNumber / this.totalChunks) * 100);
                }

                this.uploadMessage = 'Processing...';
                const response = await this.combineChunks(file, 'package', this.uniqueIdentifier);
                this.row.media_base64[i] = response.data.file_url;

                this.uploading = false;
                this.uploadMessage = 'Upload Complete!';
                setTimeout(() => { this.uploadMessage = ''; }, 2000);
            },

            // active status
            onStatus(){
                if(this.row.status)
                    this.row.status = 0;
                else
                    this.row.status = 1;
            },
            onHome(){
                if(this.row.view_in_home)
                    this.row.view_in_home = 0;
                else
                    this.row.view_in_home = 1;
            },

            // view in menu
            onViewInMenu(){
                if(this.row.view_in_menu) {
                    this.row.view_in_menu = 0;
                    this.orderDisplay = 'none';
                }
                else {
                    this.row.view_in_menu = 1;
                    this.orderDisplay = 'block';
                }
            },
            // view in sub menu
            onViewInSubMenu(){
                if(this.row.view_in_sub_menu) {
                    this.row.view_in_sub_menu = 0;
                    this.inputDisplay = 'none';
                }
                else {
                    this.row.view_in_sub_menu = 1;
                    this.inputDisplay = 'block';
                }
            },

            // fetchMenus
            fetchMenus() {
                this.menuLoading = true;
                this.axios.defaults.headers.common = {
                    'X-Requested-With': 'XMLHttpRequest', // security to prevent CSRF attacks
                    'Authorization': `Bearer ` + this.auth.access_token,
                };
                const options = {
                    url: window.baseURL+'/menus',
                    method: 'GET',
                    data: {},
                    params: {
                        tenant_id: this.tenant_id,
                        paginate: 100,
                    },
                }
                this.axios(options)
                .then(res => {
                    this.menuLoading = false;
                    this.menus = res.data.rows;    
                })
                .catch(() => {})
                .finally(() => {});
            },

            onDestination(){
                if(this.row.view_in_destination_home)
                    this.row.view_in_destination_home = 0;
                else
                    this.row.view_in_destination_home = 1;
            },
            onCombindTour(){
                if(this.row.is_combined_tour)
                    this.row.is_combined_tour = 0;
                else
                    this.row.is_combined_tour = 1;
            },


            // toggleCollapse
            collapseToggle(div) {
                if (div == 'Status') {
                    this.fetchMenus(); 
                }
                let el = document.querySelector("span#iconToggle"+div);
                if(el.classList.contains('ti-angle-down')) {
                    el.classList.remove('ti-angle-down');
                    el.classList.add('ti-angle-up');
                } else {
                    el.classList.remove('ti-angle-up');
                    el.classList.add('ti-angle-down');
                }
            },

            // Cancel
            cancel(){
                if(confirm('Are You Sure?')) {
                    this.$router.push({ name: this.refs });
                }
            },

            async uploadChunk(file, chunkNumber, chunkSize = this.chunkSize, totalChunks = this.totalChunks, uniqueIdentifier = this.uniqueIdentifier) {
                const start = (chunkNumber - 1) * chunkSize;
                const end = Math.min(start + chunkSize, file.size);
                const chunk = file.slice(start, end);
                const formData = new FormData();
                formData.append('file', chunk);
                formData.append('chunkNumber', chunkNumber);
                formData.append('totalChunks', totalChunks);
                formData.append('originalName', file.name);
                formData.append('uniqueIdentifier', uniqueIdentifier);
                const instance = this.axios.create({
                    baseURL: window.baseURL,
                    headers: {
                        'Authorization': `Bearer ${this.auth.access_token}`,
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });
                return instance.post('/upload-chunk', formData);
            },
            async combineChunks(file, folder = 'package', uniqueIdentifier) {
                const instance = this.axios.create({
                    baseURL: window.baseURL,
                    headers: {
                        'Authorization': `Bearer ${this.auth.access_token}`,
                        'Content-Type': 'application/json',
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                });
                return instance.post('/combine-chunks', {
                    totalChunks: Math.ceil(file.size / this.chunkSize),
                    originalName: file.name,
                    uniqueIdentifier, // pass it here
                    folder
                });
            },
            onMoreMediaFileChange(e, i, j) {
                const file = e.target.files[0];
                if (!file) return;
                const temp = this.row.more_media_temp[i][j];
                this.$set(temp, 'file', file);
                this.$set(temp, 'fileType', file.type);
                this.$set(temp, 'uploading', true);
                this.$set(temp, 'progress', 0);

                const chunkSize = this.chunkSize || 30 * 1024 * 1024;
                const totalChunks = Math.ceil(file.size / chunkSize);
                const uniqueIdentifier = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${file.name.replace(/\.[^/.]+$/, "")}`;

                const uploadChunks = async () => {
                    for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
                        await this.uploadChunk(file, chunkNumber, chunkSize, totalChunks, uniqueIdentifier);
                        this.$set(temp, 'progress', Math.round((chunkNumber / totalChunks) * 100));
                    }
                    const response = await this.combineChunks(file, 'package', uniqueIdentifier);
                    const url = response.data.file_url;
                    this.$set(temp, 'url', url);
                    this.$set(temp, 'uploading', false);
                };
                uploadChunks();
            },
            async addMoreMedia(i, j) {
                const temp = this.row.more_media_temp[i][j];
                // Allow add if either a file is uploaded (temp.url) or a link is provided (temp.link), and title is present
                if (!temp || !temp.title || (!temp.url && !temp.link)) {
                    iziToast.warning({ title: 'Error', message: 'Please upload a file or enter a link, and enter a title.' });
                    return;
                }
                if (!this.row.more_media[i]) this.$set(this.row.more_media, i, []);
                this.row.more_media[i].push({
                    id: (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : (Date.now() + '-' + Math.random().toString(36).substr(2, 16)),
                    url: temp.url ? temp.url : temp.link,
                    link: temp.link,
                    title: temp.title,
                    fileType: temp.url ? (temp.fileType || '') : 'link',
                    short_description: temp.short_description || '',
                });
                // Clear temp and file input for this form
                this.row.more_media_temp[i].splice(j, 1);
                if (this.$refs['moreMediaFileInput'+i+'_'+j] && this.$refs['moreMediaFileInput'+i+'_'+j][0]) {
                    this.$refs['moreMediaFileInput'+i+'_'+j][0].value = '';
                }
            },
            removeMoreMedia(i, id) {
                if (this.row.more_media[i]) {
                    const index = this.row.more_media[i].findIndex(m => String(m.id) === String(id));
                    if (index !== -1) {
                        this.row.more_media[i].splice(index, 1);
                        if (this.row.more_media[i].length === 0) {
                            // Remove the property to force reactivity
                            this.$delete(this.row.more_media, i);
                        } else {
                            // Force reactivity for non-empty arrays
                            this.$set(this.row.more_media, i, [...this.row.more_media[i]]);
                        }
                    }
                }
            },
            async uploadMoreMediaFileChunked(file, i) {
                // You can show a progress bar per file if you want, or just a loading state
                const chunkSize = this.chunkSize || 30 * 1024 * 1024;
                const totalChunks = Math.ceil(file.size / chunkSize);
                const uniqueIdentifier = `${Date.now()}-${Math.random().toString(36).substr(2, 9)}-${file.name.replace(/\.[^/.]+$/, "")}`;

                // Optionally, you can add a loading state for this upload
                this.$set(this.row.more_media_temp[i], 'uploading', true);

                for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
                    await this.uploadChunk(file, chunkNumber, chunkSize, totalChunks, uniqueIdentifier);
                    // Optionally, update progress here
                    // this.$set(this.row.more_media_temp[i], 'progress', Math.round((chunkNumber / totalChunks) * 100));
                }

                // Combine chunks and get the final URL
                const response = await this.combineChunks(file, 'package', uniqueIdentifier);
                this.$set(this.row.more_media_temp[i], 'url', response.data.file_url);
                this.$set(this.row.more_media_temp[i], 'uploading', false);
            },
            opnMoreMedia(i) {
                if (!this.row.more_media_temp[i]) this.$set(this.row.more_media_temp, i, []);
                this.row.more_media_temp[i].push({});
            },
        },
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.upload-overlay {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: rgba(255,255,255,0.7);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}
.upload-modal {
  background: #fff;
  padding: 2rem 3rem;
  border-radius: 8px;
  box-shadow: 0 2px 16px rgba(0,0,0,0.15);
  text-align: center;
}
</style>
